import { SagaIterator } from "redux-saga";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { createIntegLogReportApi } from "./api";
import { IntegrationLogReportReduxTypes, IntegrationLogReportSaga } from "./types";

function* createIntegLogReport({ payload }: IntegrationLogReportSaga): SagaIterator {
    try {
        const response = yield call(createIntegLogReportApi, payload);
        yield put({
            type: IntegrationLogReportReduxTypes.INTEG_LOG_REPORT_SUCCESS,
            payload: { data: response.data.data }
        })
    } catch (error: any) {
        yield put({
            type: IntegrationLogReportReduxTypes.INTEG_LOG_REPORT_ERROR,
            payload:{ error: error }
    })
}
}

export function* watchCreateIntegLogReport(){
yield takeEvery(IntegrationLogReportReduxTypes.INTEG_LOG_REPORT,createIntegLogReport)
}

function* integLogReportSaga(){
    yield all([fork(watchCreateIntegLogReport)])
}

export default integLogReportSaga;

